/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContractReferenceCreate,
  ContractReferenceListResponse,
  ContractReferenceResponse,
  ContractReferenceUpdate,
  HTTPValidationError,
  ListContractReferencesParams,
  ListPostalCodesParams,
  PostalCodeCreate,
  PostalCodeListResponse,
  PostalCodeResponse
} from '../model';

import { apiInstance } from '../../lib/apiInstance';




/**
 * Create a new postal code (Admin only)
 * @summary Create Postal Code
 */
export const createPostalCode = (
    postalCodeCreate: PostalCodeCreate,
 signal?: AbortSignal
) => {


      return apiInstance<PostalCodeResponse>(
      {url: `/api/access-control/postal-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postalCodeCreate, signal
    },
      );
    }



export const getCreatePostalCodeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPostalCode>>, TError,{data: PostalCodeCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPostalCode>>, TError,{data: PostalCodeCreate}, TContext> => {

const mutationKey = ['createPostalCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPostalCode>>, {data: PostalCodeCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPostalCode(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePostalCodeMutationResult = NonNullable<Awaited<ReturnType<typeof createPostalCode>>>
    export type CreatePostalCodeMutationBody = PostalCodeCreate
    export type CreatePostalCodeMutationError = HTTPValidationError

    /**
 * @summary Create Postal Code
 */
export const useCreatePostalCode = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPostalCode>>, TError,{data: PostalCodeCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPostalCode>>,
        TError,
        {data: PostalCodeCreate},
        TContext
      > => {
      return useMutation(getCreatePostalCodeMutationOptions(options), queryClient);
    }
    /**
 * List all postal codes (Admin only)
 * @summary List Postal Codes
 */
export const listPostalCodes = (
    params?: ListPostalCodesParams,
 signal?: AbortSignal
) => {


      return apiInstance<PostalCodeListResponse>(
      {url: `/api/access-control/postal-codes`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPostalCodesQueryKey = (params?: ListPostalCodesParams,) => {
    return [
    `/api/access-control/postal-codes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPostalCodesQueryOptions = <TData = Awaited<ReturnType<typeof listPostalCodes>>, TError = HTTPValidationError>(params?: ListPostalCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPostalCodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPostalCodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPostalCodes>>> = ({ signal }) => listPostalCodes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPostalCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPostalCodesQueryResult = NonNullable<Awaited<ReturnType<typeof listPostalCodes>>>
export type ListPostalCodesQueryError = HTTPValidationError


export function useListPostalCodes<TData = Awaited<ReturnType<typeof listPostalCodes>>, TError = HTTPValidationError>(
 params: undefined |  ListPostalCodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPostalCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPostalCodes>>,
          TError,
          Awaited<ReturnType<typeof listPostalCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPostalCodes<TData = Awaited<ReturnType<typeof listPostalCodes>>, TError = HTTPValidationError>(
 params?: ListPostalCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPostalCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPostalCodes>>,
          TError,
          Awaited<ReturnType<typeof listPostalCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPostalCodes<TData = Awaited<ReturnType<typeof listPostalCodes>>, TError = HTTPValidationError>(
 params?: ListPostalCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPostalCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Postal Codes
 */

export function useListPostalCodes<TData = Awaited<ReturnType<typeof listPostalCodes>>, TError = HTTPValidationError>(
 params?: ListPostalCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPostalCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPostalCodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a postal code by ID (Admin only)
 * @summary Get Postal Code
 */
export const getPostalCode = (
    postalCodeId: string,
 signal?: AbortSignal
) => {


      return apiInstance<PostalCodeResponse>(
      {url: `/api/access-control/postal-codes/${postalCodeId}`, method: 'GET', signal
    },
      );
    }




export const getGetPostalCodeQueryKey = (postalCodeId: string,) => {
    return [
    `/api/access-control/postal-codes/${postalCodeId}`
    ] as const;
    }


export const getGetPostalCodeQueryOptions = <TData = Awaited<ReturnType<typeof getPostalCode>>, TError = HTTPValidationError>(postalCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostalCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPostalCodeQueryKey(postalCodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPostalCode>>> = ({ signal }) => getPostalCode(postalCodeId, signal);





   return  { queryKey, queryFn, enabled: !!(postalCodeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPostalCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPostalCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPostalCode>>>
export type GetPostalCodeQueryError = HTTPValidationError


export function useGetPostalCode<TData = Awaited<ReturnType<typeof getPostalCode>>, TError = HTTPValidationError>(
 postalCodeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostalCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPostalCode>>,
          TError,
          Awaited<ReturnType<typeof getPostalCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPostalCode<TData = Awaited<ReturnType<typeof getPostalCode>>, TError = HTTPValidationError>(
 postalCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostalCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPostalCode>>,
          TError,
          Awaited<ReturnType<typeof getPostalCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPostalCode<TData = Awaited<ReturnType<typeof getPostalCode>>, TError = HTTPValidationError>(
 postalCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostalCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Postal Code
 */

export function useGetPostalCode<TData = Awaited<ReturnType<typeof getPostalCode>>, TError = HTTPValidationError>(
 postalCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostalCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPostalCodeQueryOptions(postalCodeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Delete a postal code (Admin only)
 * @summary Delete Postal Code
 */
export const deletePostalCode = (
    postalCodeId: string,
 signal?: AbortSignal
) => {


      return apiInstance<unknown>(
      {url: `/api/access-control/postal-codes/${postalCodeId}`, method: 'DELETE', signal
    },
      );
    }



export const getDeletePostalCodeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePostalCode>>, TError,{postalCodeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePostalCode>>, TError,{postalCodeId: string}, TContext> => {

const mutationKey = ['deletePostalCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePostalCode>>, {postalCodeId: string}> = (props) => {
          const {postalCodeId} = props ?? {};

          return  deletePostalCode(postalCodeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePostalCodeMutationResult = NonNullable<Awaited<ReturnType<typeof deletePostalCode>>>

    export type DeletePostalCodeMutationError = HTTPValidationError

    /**
 * @summary Delete Postal Code
 */
export const useDeletePostalCode = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePostalCode>>, TError,{postalCodeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePostalCode>>,
        TError,
        {postalCodeId: string},
        TContext
      > => {
      return useMutation(getDeletePostalCodeMutationOptions(options), queryClient);
    }
    /**
 * Create a new contract reference (Admin only)
 * @summary Create Contract Reference
 */
export const createContractReference = (
    contractReferenceCreate: ContractReferenceCreate,
 signal?: AbortSignal
) => {


      return apiInstance<ContractReferenceResponse>(
      {url: `/api/access-control/contract-references`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contractReferenceCreate, signal
    },
      );
    }



export const getCreateContractReferenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractReference>>, TError,{data: ContractReferenceCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createContractReference>>, TError,{data: ContractReferenceCreate}, TContext> => {

const mutationKey = ['createContractReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContractReference>>, {data: ContractReferenceCreate}> = (props) => {
          const {data} = props ?? {};

          return  createContractReference(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContractReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof createContractReference>>>
    export type CreateContractReferenceMutationBody = ContractReferenceCreate
    export type CreateContractReferenceMutationError = HTTPValidationError

    /**
 * @summary Create Contract Reference
 */
export const useCreateContractReference = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractReference>>, TError,{data: ContractReferenceCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContractReference>>,
        TError,
        {data: ContractReferenceCreate},
        TContext
      > => {
      return useMutation(getCreateContractReferenceMutationOptions(options), queryClient);
    }
    /**
 * List all contract references (Admin only)
 * @summary List Contract References
 */
export const listContractReferences = (
    params?: ListContractReferencesParams,
 signal?: AbortSignal
) => {


      return apiInstance<ContractReferenceListResponse>(
      {url: `/api/access-control/contract-references`, method: 'GET',
        params, signal
    },
      );
    }




export const getListContractReferencesQueryKey = (params?: ListContractReferencesParams,) => {
    return [
    `/api/access-control/contract-references`, ...(params ? [params] : [])
    ] as const;
    }


export const getListContractReferencesQueryOptions = <TData = Awaited<ReturnType<typeof listContractReferences>>, TError = HTTPValidationError>(params?: ListContractReferencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractReferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContractReferencesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContractReferences>>> = ({ signal }) => listContractReferences(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContractReferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListContractReferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listContractReferences>>>
export type ListContractReferencesQueryError = HTTPValidationError


export function useListContractReferences<TData = Awaited<ReturnType<typeof listContractReferences>>, TError = HTTPValidationError>(
 params: undefined |  ListContractReferencesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractReferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContractReferences>>,
          TError,
          Awaited<ReturnType<typeof listContractReferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContractReferences<TData = Awaited<ReturnType<typeof listContractReferences>>, TError = HTTPValidationError>(
 params?: ListContractReferencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractReferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContractReferences>>,
          TError,
          Awaited<ReturnType<typeof listContractReferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContractReferences<TData = Awaited<ReturnType<typeof listContractReferences>>, TError = HTTPValidationError>(
 params?: ListContractReferencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractReferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Contract References
 */

export function useListContractReferences<TData = Awaited<ReturnType<typeof listContractReferences>>, TError = HTTPValidationError>(
 params?: ListContractReferencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractReferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListContractReferencesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a contract reference by ID (Admin only)
 * @summary Get Contract Reference
 */
export const getContractReference = (
    contractRefId: string,
 signal?: AbortSignal
) => {


      return apiInstance<ContractReferenceResponse>(
      {url: `/api/access-control/contract-references/${contractRefId}`, method: 'GET', signal
    },
      );
    }




export const getGetContractReferenceQueryKey = (contractRefId: string,) => {
    return [
    `/api/access-control/contract-references/${contractRefId}`
    ] as const;
    }


export const getGetContractReferenceQueryOptions = <TData = Awaited<ReturnType<typeof getContractReference>>, TError = HTTPValidationError>(contractRefId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractReference>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractReferenceQueryKey(contractRefId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractReference>>> = ({ signal }) => getContractReference(contractRefId, signal);





   return  { queryKey, queryFn, enabled: !!(contractRefId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractReference>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractReferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getContractReference>>>
export type GetContractReferenceQueryError = HTTPValidationError


export function useGetContractReference<TData = Awaited<ReturnType<typeof getContractReference>>, TError = HTTPValidationError>(
 contractRefId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractReference>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractReference>>,
          TError,
          Awaited<ReturnType<typeof getContractReference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractReference<TData = Awaited<ReturnType<typeof getContractReference>>, TError = HTTPValidationError>(
 contractRefId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractReference>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractReference>>,
          TError,
          Awaited<ReturnType<typeof getContractReference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractReference<TData = Awaited<ReturnType<typeof getContractReference>>, TError = HTTPValidationError>(
 contractRefId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractReference>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Contract Reference
 */

export function useGetContractReference<TData = Awaited<ReturnType<typeof getContractReference>>, TError = HTTPValidationError>(
 contractRefId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractReference>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractReferenceQueryOptions(contractRefId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Update a contract reference (Admin only)
 * @summary Update Contract Reference
 */
export const updateContractReference = (
    contractRefId: string,
    contractReferenceUpdate: ContractReferenceUpdate,
 signal?: AbortSignal
) => {


      return apiInstance<ContractReferenceResponse>(
      {url: `/api/access-control/contract-references/${contractRefId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contractReferenceUpdate, signal
    },
      );
    }



export const getUpdateContractReferenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractReference>>, TError,{contractRefId: string;data: ContractReferenceUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContractReference>>, TError,{contractRefId: string;data: ContractReferenceUpdate}, TContext> => {

const mutationKey = ['updateContractReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContractReference>>, {contractRefId: string;data: ContractReferenceUpdate}> = (props) => {
          const {contractRefId,data} = props ?? {};

          return  updateContractReference(contractRefId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateContractReference>>>
    export type UpdateContractReferenceMutationBody = ContractReferenceUpdate
    export type UpdateContractReferenceMutationError = HTTPValidationError

    /**
 * @summary Update Contract Reference
 */
export const useUpdateContractReference = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractReference>>, TError,{contractRefId: string;data: ContractReferenceUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContractReference>>,
        TError,
        {contractRefId: string;data: ContractReferenceUpdate},
        TContext
      > => {
      return useMutation(getUpdateContractReferenceMutationOptions(options), queryClient);
    }




/**
 * Delete a contract reference (Admin only)
 * @summary Delete Contract Reference
 */
export const deleteContractReference = (
    contractRefId: string,
 signal?: AbortSignal
) => {


      return apiInstance<unknown>(
      {url: `/api/access-control/contract-references/${contractRefId}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteContractReferenceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContractReference>>, TError,{contractRefId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteContractReference>>, TError,{contractRefId: string}, TContext> => {

const mutationKey = ['deleteContractReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContractReference>>, {contractRefId: string}> = (props) => {
          const {contractRefId} = props ?? {};

          return  deleteContractReference(contractRefId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteContractReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContractReference>>>

    export type DeleteContractReferenceMutationError = HTTPValidationError

    /**
 * @summary Delete Contract Reference
 */
export const useDeleteContractReference = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContractReference>>, TError,{contractRefId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContractReference>>,
        TError,
        {contractRefId: string},
        TContext
      > => {
      return useMutation(getDeleteContractReferenceMutationOptions(options), queryClient);
    }
